/***========== FOOTER COLLAPSIBLE  ============***/
jQuery(".nav-footer h2").click(function () {
   jQuery(this).parent(".nav").toggleClass("open");
});

jQuery(".nav-footer .icons-container").click(function () {
   jQuery(this).parent(".nav").toggleClass("open");
});

// /***========== FEATURED IMAGE CAROUSEL  ============***/
// let swiper = new Swiper(".mySwiper", {
//    slidesPerView: 2,
//    loop: true,
//    spaceBetween: 30,
//    navigation: {
//       nextEl: ".swiper-button-next",
//       prevEl: ".swiper-button-prev",
//    },
//    pagination: {
//       el: ".swiper-pagination",
//       clickable: true,
//    },
//    breakpoints: {
//       640: {
//          slidesPerView: 2,
//          spaceBetween: 20,
//       },
//       768: {
//          slidesPerView: 3,
//          spaceBetween: 40,
//       },
//       1024: {
//          slidesPerView: 4,
//          spaceBetween: 20,
//       },
//    },
// });


// window.addEventListener("load", function(){
// const facebookScript = document.createElement("script")
// swiperScript.src = "https://connect.facebook.net/signals/config/1881556662159012?v=2.9.51&r=stable"
// document.body.appendChild(swiperScript);
  
//   const jqueryScript = document.createElement("script")
// jqueryScript.src = "{{ 'jquery.min.js' | asset_url }}"
// document.body.appendChild(jqueryScript);
  
// })

// function redirect2(){
//    const current__URL = window.location.href;
//    if(current__URL.includes('/en-ae/collections/frontpage')){
//            window.location.replace("https://ggblue.com/");
//        }
//        }
//  redirect2();